<script lang="ts">
  import PdpGalleryModal from './PdpGalleryModal.svelte';
  import { reviewGalleryState } from '../store/pdp_store';

  let open = false;
  let images = [];
  let activeIndex = 0;
  let reviewActiveIndex = 0;

  $: open = $reviewGalleryState.open;
  $: images = $reviewGalleryState.images;
  $: activeIndex = $reviewGalleryState.activeIndex;
  $: reviewActiveIndex = Math.min(Math.max(activeIndex, 0), Math.max(images.length - 1, 0));

  function updateGalleryState(nextState) {
    reviewGalleryState.set({
      open,
      images,
      activeIndex,
      ...nextState,
    });
  }

  function closeGallery() {
    updateGalleryState({ open: false });
  }
</script>

<PdpGalleryModal
  bind:open
  galleryMode="review"
  galleryItems={images}
  initialIndex={reviewActiveIndex}
  galleryImageAlt="Review preview"
  onClose={closeGallery}
/>
